$(document).ready(function() {
	$.material.init()
});
$(document).on("click", ".nav-trigger", function() {
  $('.matwi-sidenav').toggleClass('visible');
  
});
